import { type CollectionWithProducts } from '@/sanity/schemaTypes/documents/collection';
import SanityImage from './media/SanityImage';
import { formatPrice } from '@/lib/utils';
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';

export default function ProductCard({
  product,
  locale,
  className,
  priority = false
}: {
  product: CollectionWithProducts['products'][number];
  locale: string;
  className?: string;
  priority?: boolean;
}) {
  return (
    <div className={twMerge('group relative isolate', className)}>
      <SanityImage
        width={800}
        height={600}
        // grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4
        // image is 600px on screen smaller than sm (< 40rem), 300px on screen smaller than lg (< 64rem), 380px on screen smaller than xl (< 80rem) and 280px on bigger screens
        sizes="(max-width: 40rem) 600px, (max-width: 40rem) 300px, (max-width: 64rem) 380px, 280px"
        alt={product.title}
        src={product.image.asset?._ref}
        priority={priority}
        className="aspect-[800/600] w-full overflow-hidden rounded-lg bg-gray-200 object-cover group-hover:opacity-75"
      />
      <div className="mt-4 flex items-start justify-between gap-2">
        <h3 className="text-sm text-gray-700">
          <Link href={product.slug}>
            <span aria-hidden="true" className="absolute inset-0" />
            {product.title}
          </Link>
        </h3>
        <p className="text-secondary bg-primary rounded-full px-2 py-0.5 text-sm font-medium shadow">
          {formatPrice(product.priceFrom, locale)}
        </p>
      </div>
    </div>
  );
}
